/* eslint-disable camelcase */
import React, { useContext, useEffect, useState } from 'react'
import API from 'api'
import AppLoader from 'screens/appLoader'

const initialState = () => {
  return localStorage.getItem(`token`) || null
}

const AuthContext = React.createContext()

function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [id, setID] = useState(initialState())
  const [loading, setLoading] = useState(false)

  const getMe = async () => {
    try {
      setLoading(true)
      const { data } = await new API({ endpoint: `getMe` }).send()
      setUser(data)
      setLoading(false)
    } catch (error) {
      setID(null)
      localStorage.removeItem(`token`)
      return (window.location.href = `/`)
    }
  }

  const logout = async () => {
    try {
      await new API({ endpoint: `getmeLogout` }).send()
      localStorage.removeItem(`token`)
      const url =
        user?.roles?.includes(`Admin`) || user?.roles?.includes(`Validator`) ? `/admin` : `/`
      setUser(null)
      return (window.location.href = url)
    } catch (error) {
      setLoading(false)
      return null
    }
  }

  useEffect(() => {
    id && getMe()
  }, [id])

  function logIn(id, url) {
    localStorage.setItem(`token`, id)
    setID(id)
    return (window.location.href = url)
  }

  function logOut() {
    setLoading(true)
    logout()
  }

  return (
    <AuthContext.Provider value={{ user, logIn, logOut }}>
      {loading ? <AppLoader /> : children}
    </AuthContext.Provider>
  )
}

function useAuth() {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error(`useAuth must be used within a AuthProvider`)
  }
  return context
}

export { AuthProvider, useAuth }
